import { BlogPost } from '@/types/blog';
import { WPPost } from './types';
import { transformBlogUrls, transformSingleUrl } from '@/utils/urlTransformer';
import { stripHtmlAndDecodeEntities, secureDecodeHtmlEntities } from '@/utils/secureHtmlUtils';

/**
 * Transform a WordPress post into our BlogPost format
 */
export const transformPost = (wpPost: WPPost): BlogPost => {
  // Extract featured image if available
  let featuredImage = '';
  if (wpPost._embedded?.['wp:featuredmedia']?.[0]?.source_url) {
    featuredImage = transformSingleUrl(wpPost._embedded['wp:featuredmedia'][0].source_url, true);
  }
  
  // Extract categories and tags
  const categories: string[] = [];
  const categoryIds: number[] = [];
  const tags: string[] = [];
  
  if (wpPost._embedded?.['wp:term']) {
    wpPost._embedded['wp:term'].forEach(terms => {
      terms.forEach(term => {
        if (term.taxonomy === 'category') {
          categories.push(term.name);
          categoryIds.push(term.id);
        } else if (term.taxonomy === 'post_tag') {
          tags.push(term.name);
        }
      });
    });
  }
  
  // Calculate estimated reading time
  const wordCount = wpPost.content.rendered.replace(/<[^>]+>/g, '').split(/\s+/).length;
  const readingTime = `${Math.max(1, Math.round(wordCount / 200))} min`; // Assume 200 words per minute
  
  // Basic author info (could be enhanced with actual WP author data if available)
  const author = {
    name: "Staff Gildy",
    avatar: "https://randomuser.me/api/portraits/lego/1.jpg"
  };

  // Transform any blog.gildy.it URLs in content to www.gildy.it/blog
  const transformedContent = transformBlogUrls(wpPost.content.rendered);

  // Get SEO description from Yoast if available
  const yoastDescription = wpPost.yoast_head_json?.description || wpPost.yoast_head_json?.og_description;
  
  // Clean up excerpt by removing HTML tags and decoding entities
  const cleanExcerpt = stripHtmlAndDecodeEntities(wpPost.excerpt.rendered);
  const transformedExcerpt = transformBlogUrls(cleanExcerpt);

  return {
    id: wpPost.id,
    title: secureDecodeHtmlEntities(wpPost.title.rendered),
    slug: wpPost.slug,
    date: wpPost.date,
    content: transformedContent,
    excerpt: transformedExcerpt,
    featuredImage,
    featuredImageAlt: `Immagine per ${secureDecodeHtmlEntities(wpPost.title.rendered)}`,
    categories,
    categoryIds,
    tags,
    url: `/blog/${wpPost.slug}`,
    readingTime,
    author,
    modified: wpPost.modified,
    seo: {
      description: yoastDescription || transformedExcerpt,
    }
  };
};
